import { BrandMark } from "./Brand";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__top wrap">
        <p className="site-footer__wordmark display" aria-hidden="true">
          Aquarium <em>Helpline</em>
        </p>
        <p className="site-footer__tagline">
          <BrandMark />
          Practical aquarium guidance when the internet gives you ten different answers.
        </p>
      </div>
      <div className="site-footer__grid wrap">
        <div>
          <h2 className="site-footer__heading">Explore</h2>
          <ul className="site-footer__links">
            <li><a href="/articles/">Care guides</a></li>
            <li><a href="/how-it-works/">How it works</a></li>
            <li><a href="/next-steps/">Prepare for your call</a></li>
            <li><a href="/about/">About</a></li>
          </ul>
        </div>
        <div>
          <h2 className="site-footer__heading">Get help</h2>
          <ul className="site-footer__links">
            <li><a href="/consultation/">Request a consultation</a></li>
            <li><a href="/help/">Website and purchase support</a></li>
            <li><a href="mailto:support@aquariumhelpline.com">support@aquariumhelpline.com</a></li>
          </ul>
        </div>
        <div>
          <h2 className="site-footer__heading">Hours</h2>
          <ul className="site-footer__links">
            <li>Consultations 7 days a week</li>
            <li>8am to 9pm Pacific</li>
            <li>Emergency slots outside those hours on request</li>
          </ul>
        </div>
        <div>
          <h2 className="site-footer__heading">Machine readable</h2>
          <ul className="site-footer__links">
            <li><a href="/llms.txt">llms.txt</a></li>
            <li><a href="/feed.xml">RSS feed</a></li>
            <li><a href="/sitemap.xml">Sitemap</a></li>
          </ul>
        </div>
      </div>
      <div className="site-footer__base wrap">
        <p>© {new Date().getUTCFullYear()} Aquarium Helpline</p>
        <p>
          <a href="/privacy/">Privacy</a>
          <span aria-hidden="true"> / </span>
          <a href="https://aquatic-contractors.com">Aquatic Contractors</a>
        </p>
      </div>
    </footer>
  );
}
